// extracted by mini-css-extract-plugin
export var copyContainer = "TimelineCard-module--copyContainer--m8D4H";
export var page404Title = "TimelineCard-module--page404-title--3zB04";
export var timelineCardContainer = "TimelineCard-module--timelineCardContainer--3YFzq";
export var yearContainer = "TimelineCard-module--yearContainer--2wmHk";